import React, { memo } from "react";
import Spinner from "./spinner";

const LoadingButton = memo(({ loading, children }) => {
  return (
    <>
      {loading ? (
        <div className="d-flex align-items-center ms-3">
          <Spinner />
        </div>
      ) : (
        children
      )}
    </>
  );
});
export default LoadingButton;
